import * as React from "react";
import {OnMounted}      from "@Common/react/on-mounted";

import "./fieldOptionsTools.scss";

import {cs}                      from "@Common/react/chain-services";
import {Load2}                   from "@Common/react/load2";
import {consumeContext}          from "@Common/react/context";
import {faFileLines}             from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon}         from "@fortawesome/react-fontawesome";
import {AiTextGenerationTools2}  from "@Common/ui-components/ai-text-generation/ai-text-generation-tools-2";
import {AutoTextGenerationModal} from "@Common/ui-components/ai-text-generation/auto-text-generation-modal";
import {AiTextFromImageModal}    from "@Common/ui-components/ai-text-generation/ai-text-from-image-modal";
import {MergeFields}             from "@Common/tools/cc-integration/ui/merge-fields/merge-fields";
import {SuggestedCommentsModal}  from "@Common/ui-components/suggested-comments-modal/suggested-comments-modal";

export const FieldOptionsTools = ({
    stickyBottomActive,
    idOrder=null,
    tinyMceField=null,
    ccField=null,
    fieldData,
    aiOptions=null,
    charOverrideModalOptions=null,
    allowSuggestedComments=null,
    allowVdp=null,
    mergeFieldOptions=null,
    charCount=null,
    maxChars=null,
    maxCharsExceeded=null,
    allowOverride=null,
    overrideCKValue=null,
    overrideCheckHandler=null,
    explainerText=null,
}) => cs(
    consumeContext("userData"),
    consumeContext("suggestedComments"),
    consumeContext("company"),
    ["charCount", ({}, next) => next(charCount)],
    ["textGenerationModal", ({}, next) => aiOptions ? AutoTextGenerationModal({
        idOrder: parseInt(idOrder),
        maxCharOverride: aiOptions.allowMaxCharsOverride,
        maxChars: aiOptions.maxChars,
        setFieldVal: aiOptions.onSetValue,
        next
    }) : next(null)],
    ["orderImages", ({apis}, next) => aiOptions ? Load2({
        _key: "ai_order_images_" + idOrder,
        fetch: () => apis.next.gallery.orders.getImages(idOrder),
        captureException: true,
        next,
    }) : next(null)],
    ["aiTextFromImageModal", ({}, next) => aiOptions ? AiTextFromImageModal({
        idOrder: parseInt(idOrder),
        maxCharOverride: aiOptions.allowMaxCharsOverride,
        maxChars: aiOptions.maxChars,
        setFieldVal: aiOptions.onSetValue,
        next
    }) : next(null)],

    ["suggestedCommentCallback", ({}, next) => next( (value) => {
        if (tinyMceField) {
            if (value) {
                function nl2br (str) {
                    if (typeof str === 'undefined' || str === null) {
                        return '';
                    }
                    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2');
                }
                value = nl2br(value);
                charOverrideModalOptions?.onSetValue(value);
            }
        } else if (ccField) {
            if (value) {
                charOverrideModalOptions?.onSetValue(value);
            }
        } else {
            if (value) {
                if (overrideCKValue.value) {
                    charOverrideModalOptions?.onSetValue(value);
                }
                else if (value.length > fieldData.maxLength) {
                    if (!charOverrideModalOptions?.enableLimitOverride) {
                        charOverrideModalOptions?.modalMessage.onChange('You are trying to paste/enter text with length more than allowed.');
                        charOverrideModalOptions?.okCallback.onChange(() => {charOverrideModalOptions?.showCharCountModal.onChange(false)});
                        charOverrideModalOptions?.cancelCallback.onChange(() => {charOverrideModalOptions?.showCharCountModal.onChange(false)});
                        charOverrideModalOptions?.cancelButton.onChange(false);
                        charOverrideModalOptions?.onSetValue(value.slice(0, fieldData.maxLength));
                        return charOverrideModalOptions?.showCharCountModal.onChange(true);
                    } else if (!overrideCKValue.value) {
                        charOverrideModalOptions?.modalMessage.onChange('You are trying to paste/enter text with length more than allowed. Activate override?');
                        charOverrideModalOptions?.okCallback.onChange(() => {
                            overrideCKValue.onChange(true);
                            charOverrideModalOptions?.onSetValue(value);
                            charOverrideModalOptions?.showCharCountModal.onChange(false);
                        });
                        charOverrideModalOptions?.cancelCallback.onChange(() => {
                            charOverrideModalOptions?.onSetValue(value.slice(0, fieldData.maxLength));
                            charOverrideModalOptions?.showCharCountModal.onChange(false);
                        });
                        charOverrideModalOptions?.cancelButton.onChange(true);
                        return charOverrideModalOptions?.showCharCountModal.onChange(true);
                    }
                } else {
                    charOverrideModalOptions?.onSetValue(value.slice(0, fieldData.maxLength));
                }
            }
        }
    })],
    ["suggestedCommentsModal", ({suggestedComments, userData, suggestedCommentCallback}, next) => SuggestedCommentsModal({
        next,
        suggestedComments: suggestedComments,
        setFieldVal: suggestedCommentCallback,
        userData,
        maxChars: maxChars,
    })],

    (({textGenerationModal, orderImages, aiTextFromImageModal, suggestedCommentOptions, suggestedCommentsModal}, ) => (
        <div className={stickyBottomActive ? "content-container-j43 sticky-bottom-frame" : "content-container-j43"}
            id={"content-container-j43-" + fieldData.idPrimary.toString()}
            tabIndex={1}
        >
            {(maxChars || allowOverride || explainerText) ?
                <div className="field-details">
                    {maxChars &&
                        <div className="max-chars" xd-qa-type="label" xd-qa-name="chars-count">
                            {charCount.toLocaleString()} of
                            <span className={maxCharsExceeded ? "strikethroughMaxCharacters" : "maxCharacters"} xd-qa-type="label" xd-qa-name="maxCharacters"> {maxChars.toLocaleString()} </span>
                            characters
                        </div>
                    }
                    {allowOverride &&
                        <div className="override-container">
                            <label className="custom-checkbox">
                                <input
                                    type="checkbox"
                                    xd-qa-type="checkbox"
                                    xd-qa-name={fieldData.fieldKey}
                                    data-fieldname={fieldData.displayLabel}
                                    name={fieldData.fieldKey}
                                    data-multipartfield="dataLimitOverride"
                                    checked={overrideCKValue.value}
                                    value={overrideCKValue.value ? 1 : 0}
                                    onChange={overrideCheckHandler}
                                />
                                <span className="checkmark"></span>
                            </label>
                            <p onClick={overrideCheckHandler} xd-qa-type="label" xd-qa-name="Override">Override</p>
                        </div>
                    }
                    {explainerText &&
                        <div className="explainer-text-container">
                            text auto formatted as {explainerText}
                        </div>
                    }
                </div>
            : <div></div>}
            {(aiOptions || allowSuggestedComments || allowVdp) && <div className="tools-container">
                {allowVdp && (
                <MergeFields {...{...mergeFieldOptions, idField:fieldData.idPrimary}}/>
            )}
                {aiOptions ? (
                    <AiTextGenerationTools2
                        idOrder={parseInt(idOrder)}
                        idField={fieldData.idPrimary}
                        currFieldVal={aiOptions.currentValue}
                        setFieldVal={aiOptions.onSetValue}
                        displayLoading={aiOptions.onSetLoading}
                        fieldMaxChars={aiOptions.maxChars}
                        overrideMaxChars={aiOptions.allowMaxCharsOverride}
                        textGenerationModal={textGenerationModal}
                        aiTextFromImageModal={aiTextFromImageModal}
                        orderImages={orderImages}
                    />
                ) : null}
                {allowSuggestedComments &&
                    <div
                        className="suggested-copy-button"
                        xd-qa-type="button" xd-qa-name="Text Gen Tools Button AI"
                        onClick={suggestedCommentsModal.show}
                    >
                        <FontAwesomeIcon className="icon" icon={faFileLines}/>
                        <p xd-qa-type="label" xd-qa-name="Suggested Copy">Suggested Copy</p>
                    </div>
                }
            </div>}
        </div>
    ))
);